
import articlesRepository from "./articlesRepository"
import bibleRepository from "./bibleRepository"
import bibleTranslationsRepository from "./bibleTranslationsRepository"
import churchesRepository from "./churchesRepository"
import configsRepository from "./configsRepository"
import eventsRepository from "./eventsRepository"
import groupsRepository from "./groupsRepository";
import profileRepository from "./profileRepository";
import projectsRepository from "./projectsRepository"
import topicsRepository from "./topicsRepository"
import usersRepository from "./usersRepository"
import plannedArticlesRepository from "./plannedArticlesRepository"
import readingPlansRepository from "./readingPlansRepository"
import songRepository from "./songRepository"
import emailRepository from "./emailRepository"

const repositories = {
    articles: articlesRepository,
    bible: bibleRepository,
    bible_translations: bibleTranslationsRepository,
    churches: churchesRepository,
    configs: configsRepository,
    events: eventsRepository,
    groups: groupsRepository,
    profile: profileRepository,
    projects: projectsRepository,
    topics: topicsRepository,
    users: usersRepository,
    plannedArticles: plannedArticlesRepository,
    readingPlans: readingPlansRepository,
    songs: songRepository,
    email: emailRepository
};

export const RepositoryFactory = {
    get: name => repositories[name]
};